/*
  * Address component specific for Adalia M&E.
  * This is a composite based on other components.
  */
import React from 'react';

import Helpers from './helpers.jsx'

import GridLayout from './grid_layout.jsx';
import LongTextField from './long_text_field.jsx';
import TextField from './text_field.jsx';
import DropdownSelection from './dropdown_selection.jsx';

import { AdaliaMEMapGrid, AdaliaMEMap } from "./adalia_me_map_fields.jsx";

export default class AdaliaMeAddress extends GridLayout {
        static get CATEGORY() {
            return 'question';
        }

        static get TYPE() {
            return 'adalia_me_address';
        }

        static icon(){
            return <i className="fa fa-map-marker"></i>;
        }


        static defaultContent(language) {
            let fieldName = 'field_' + Helpers.randomString();

            let streetTranslations = LongTextField.defaultContentTranslations(language);
            streetTranslations[language] = Object.assign(streetTranslations[language], {
                label: I18n.t('field_default_street_address', {scope: 'fe', locale: language}),
                description: '',
                placeholder: ''
            });
            let postCodeTranslations = TextField.defaultContentTranslations(language);
            postCodeTranslations[language] = Object.assign(postCodeTranslations[language], {
                label: I18n.t('field_default_postal_code', {scope: 'fe', locale: language}),
                description: '',
                placeholder: ''
            });
            let cityTranslations = TextField.defaultContentTranslations(language);
            cityTranslations[language] = Object.assign(cityTranslations[language], {
                label: I18n.t('field_default_city', { scope: 'fe', locale: language }),
                description: '',
                placeholder: ''
            });
            let countryTranslations = DropdownSelection.defaultContentTranslations(language);
            countryTranslations[language] = Object.assign(countryTranslations[language], {
                label: I18n.t('field_default_country', { scope: 'fe', locale: language }),
                description: ''
            });

            return Object.assign(super.defaultContent(language), {
                rows: [
                    [
                        {
                            span: 1,
                            component: Object.assign(AdaliaMEAddressGrid.defaultContent(language), {
                                deletable: false,
                                sortable: false,
                                rows: [
                                    [
                                        {
                                            span: 1,
                                            component: Object.assign(LongTextField.defaultContent(language), {
                                                name: fieldName + '_street_address',
                                                deletable: false,
                                                sortable: false,
                                                translations: streetTranslations
                                            })
                                        }
                                    ],
                                    [
                                        {
                                            span: 1,
                                            component: Object.assign(TextField.defaultContent(language), {
                                                name: fieldName + '_postal_code',
                                                deletable: false,
                                                sortable: false,
                                                translations: postCodeTranslations
                                            })
                                        }
                                    ],
                                    [
                                        {
                                            span: 1,
                                            component: Object.assign(TextField.defaultContent(language), {
                                                name: fieldName + '_city',
                                                deletable: false,
                                                sortable: false,
                                                translations: cityTranslations
                                            })
                                        }
                                    ],
                                    [
                                        {
                                            span: 1,
                                            component: Object.assign(DropdownSelection.defaultContent(language), {
                                                name: fieldName + '_country',
                                                deletable: false,
                                                sortable: false,
                                                options: [
                                                    {
                                                        options: [],
                                                        dependency: "_default"
                                                    }
                                                ],
                                                dataType: "string",
                                                includeBlank: true,
                                                translations: countryTranslations
                                            })
                                        }
                                    ]
                                ]
                            })
                        },
                        {
                            span: 1,
                            component: Object.assign(AdaliaMEAddressMap.defaultContent(language), {
                                name: fieldName + '_coordinates'
                            })
                        }
                    ]
                ]
            });
        }

        constructor(props) {
            super(props);
        }

        componentDidMount() {
            super.componentDidMount();

            if (typeof this.props.updateSettingsCallback == 'function') {
                let content = this.props.content;
                if (content.isNewComponent) {
                    content.rows[0][0].component.rows.forEach((comp, i) => {
                        content.rows[0][0].component.rows[i][0].component.isNewComponent = true;
                    })
                    content.rows[0][1].component.isNewComponent = true;
                    this.props.updateSettingsCallback(content.id, content, true);
                }
            }
        }

        renderSettings() {
        }
}


export class AdaliaMEAddressGrid extends AdaliaMEMapGrid {
    static get TYPE() {
        return "adalia_me_address_grid";
    }
}

export class AdaliaMEAddressMap extends AdaliaMEMap {
    static get TYPE() {
        return "adalia_me_address_map";
    }

    static get PARENT_TYPE() {
        return "adalia_me_address";
    }

    constructor(props) {
        super(props);

        this.coordinatesRef = React.createRef();
        this.locationNameRef = React.createRef();
    }

    renderAfterMap() {
        return (
            <>
                <input ref={this.coordinatesRef} type="hidden" name={this.fullFieldName()} defaultValue={this.getAnswer()} />
                <input ref={this.locationNameRef} type="hidden" defaultValue="" />
                <p className="description">{I18n.t("adalia_me_address_map_hint", { scope: "fe", locale: this.props.language })}</p>
            </>
        );
    }

    getFillModeOptions() {
        return {
            ...super.getFillModeOptions(),
            inputBinding: {
                locationNameInput: jQuery(this.locationNameRef.current),
            },
        };
    }

    fieldInitialized() {
        return jQuery(this.coordinatesRef.current).length > 0;
    }

    getInitialLocation() {
        let coordinatesInput = jQuery(this.coordinatesRef.current);

        let initialLocation = {
            latitude: "0.0",
            longitude: "0.0",
        };

        // Init map from hidden input coordinates
        if (coordinatesInput.val() != "") {
            let l = coordinatesInput.val().split(",");
            initialLocation = { latitude: l[0], longitude: l[1] };
        }

        return initialLocation;
    }

    componentDidMount() {
        super.componentDidMount();

        let locationNameInput = jQuery(this.locationNameRef.current);

        // Blur is the event listened by locationpicker. It also expects the originalEvent-attribute.
        locationNameInput.on("change", (event) => {
            locationNameInput.trigger(jQuery.Event("blur", { originalEvent: true }));
        });
    }

    initInputEvents(inputGrid, mapContainer) {
        const locationNameInput = jQuery(this.locationNameRef.current);
        const coordinatesInput = jQuery(this.coordinatesRef.current);

        // Update map when address fields are changed
        inputGrid.on(
            "change keyup blur focus",
            "input, textarea, select",
            _.throttle(() => {
                let countrySelect = inputGrid.find('[name*="country"]');
                let addrStr = [
                    inputGrid.find('[name*="street_address"]').val() || null,
                    inputGrid.find('[name*="postal_code"]').val() || null,
                    inputGrid.find('[name*="city"]').val() || null,
                    countrySelect.val() ? countrySelect.find("option:selected")?.text() : null,
                ]
                    .filter((s) => s)
                    .join(",");
                if (addrStr != "") {
                    let mapContext = mapContainer.locationpicker("map");
                    locationNameInput.val(addrStr).trigger(jQuery.Event("change", { originalEvent: true }));

                    if (coordinatesInput.val() != "") {
                        mapContext.map.setZoom(15);
                    }
                }
            }, 2000)
        );
    }

    locationChanged = (location) => {
        jQuery(this.coordinatesRef.current).val([location.latitude, location.longitude].join(","));
        this.updateAnswer();
    }
}
